/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useState } from "react";
import SwanLogo from "./SwanLogo";
import TryonResult from "./tryonResult/TryonResult";
import ScanMeasurementCompo from "./ScanMeasurementCompo";
import FeaturesCompo from "./FeaturesCompo";
import { BOTTOM_VIEW } from "../services/constant";
import ProductDetails from "./ProductDetails";
import ParamsContext from "../context/ParamsContext";
import { useTheme } from "../context/ThemeContext";
import TryonResultSlider from "./TryonResultSlider";
import Loading from "./loading/Loading";

const ResultDetails = () => {
	const [bottomView, setBottomView] = useState(BOTTOM_VIEW.NONE);
	const { tryonData, scanData, IsToShowCaraousal,tryonLoading } = useContext(ParamsContext);
	const { theme } = useTheme();
	const renderContentClass = `inset-x-0 bottom-0 backdrop-blur-sm z-[6] rounded-t-xl transition-all duration-300 ease-in-out overflow-hidden ${
		tryonData || tryonLoading  ? "h-[40%] absolute shadow-lg" : "h-full pl-[42px]"
	} ${theme === "light" ? "bg-white/95 text-gray-900" : "bg-black/95 text-gray-100"}`;
	const renderInnerClass = "relative h-full p-4 pr-0";
	const render = useCallback(() => {
		switch (bottomView) {
			case BOTTOM_VIEW.PRODUCT:
				return (
					<div className={renderContentClass}>
						<div className={renderInnerClass}>
							<ProductDetails setBottomView={setBottomView} />
						</div>
					</div>
				);
			case BOTTOM_VIEW.MEASUREMENT:
				return (
					<div className={renderContentClass}>
						<div className={renderInnerClass}>
							<ScanMeasurementCompo setBottomView={setBottomView} />
						</div>
					</div>
				);
			default: {
				return <></>;
			}
		}
	}, [bottomView, renderContentClass]);

	const renderMain = useCallback(() => {
		if (scanData && !tryonData && !tryonLoading ) {
			return <ScanMeasurementCompo />;
		} else {
			return tryonLoading ?<div className="flex items-center justify-center w-full h-full pb-[40%] aspect-[2/2.5]"><Loading
      height="auto"
      width="auto" isAnimation /></div> :<TryonResult />;
		}
	}, [scanData, tryonData,tryonLoading]);

	useEffect(() => {
		if (scanData && (tryonData ||  tryonLoading)) {
			setBottomView(BOTTOM_VIEW.MEASUREMENT);
		}
	}, [scanData, tryonData]);

	return (
		<div
			className={`rounded-xl overflow-hidden max-w-[510px] mx-auto mt-[10px] shadow-md relative transition-all duration-300 ${theme === "light" ? "bg-white text-gray-900" : "bg-black text-gray-100"}`}
		>
			<div className="flex space-x-2 items-center justify-center p-3">
				<div className="flex items-center justify-center">
					<SwanLogo logoText={true} />
				</div>

				{/* <span className="font-medium text-[16px]">Swan</span> */}
			</div>
			<div className={`relative ${tryonData ? "min-h-[300px]" : "min-h-[150px]"}`}>
				<FeaturesCompo setBottomView={setBottomView} />
				{IsToShowCaraousal ? <TryonResultSlider /> : renderMain()}
				{render()}
			</div>
		</div>
	);
};

export default ResultDetails;
